export default class ServiceList {
	constructor() {
		this.listWrapper = document.querySelector(".services-wrapper");
		this.listButtons = this.listWrapper.querySelectorAll(
			".service-list-item button"
		);
		this.serviceDescriptions = this.listWrapper.querySelectorAll(
			".service-description"
		);
		this.init();
		this.events();
	}

	init() {}

	onButtonClick(ev) {
		// Hide all content wrappers
		this.serviceDescriptions.forEach((element) => {
			element.classList.add("hidden");
		});

		// Reset buttons
		this.listButtons.forEach((button) => {
			button.classList.remove("font-semibold");
			button.classList.remove("active");
		});

		const btn = ev.currentTarget;
		const dataControls = btn.getAttribute("data-controls");
		const targetContent = document.querySelectorAll("." + dataControls);
		btn.classList.add("font-semibold");
		btn.classList.add("active");
		targetContent.forEach((el) => {
			el.classList.remove("hidden");
		});
	}

	events() {
		this.listButtons.forEach((button) => {
			button.addEventListener("click", this.onButtonClick.bind(this), false);
		});
	}
}
